import * as actions from "Actions";
import * as api from "Api";
import { pushSourceToken } from "Utils";

export const fetchLatestTopics = ({ limit }) => {
  return (dispatch, getState) => {
    let sourceToken = pushSourceToken("FETCH_LATEST_TOPICS", dispatch);

    const { lng } = getState().params;
    const { auth } = getState();
    const { token, navCommunity } = auth;

    return dispatch(
      actions.fetchTopics(
        api.getLatestTopics({
          token,
          limit,
          language: lng,
          community: navCommunity ? navCommunity.id : null,
          sourceToken
        })
      )
    );
  };
};

export const fetchTopic = topicId => {
  return (dispatch, getState) => {
    const { token } = getState().auth;

    return dispatch(
      actions.fetchSingleTopic(api.getSingleTopic(token, topicId))
    );
  };
};

/*export const fetchTopicComments = ({ limit = 20, objectType, objectId }) => (
  dispatch,
  getState
) => {
  const { auth } = getState();
  const { token } = auth;

  return dispatch(
    actions.fetchTopicComments(
      api.fetchTopicComments({
        token,
        limit,
        objectType,
        objectId
      })
    )
  );
};*/

/*export const saveTopicComment = ({ comment, id }) => (dispatch, getState) => {
  const { token } = getState().auth;
  return dispatch(
    actions.saveTopicComment(
      api.saveTopicComment({
        token,
        comment,
        topicId: id
      })
    )
  );
};*/



// WEBPACK FOOTER //
// ./src/actions/thunks/topic.js